import { User, AuthToken } from "../model";

/**
 * 인증 엔티티 관련 기본 함수들
 * 데이터 변환, 포맷팅, 검증 등
 */

/**
 * 토큰 만료 시간 확인
 */
export const isTokenExpired = (token: AuthToken): boolean => {
  if (!token.expiresIn) return false;
  return Date.now() > token.expiresIn * 1000;
};

/**
 * 사용자 정보 포맷팅
 */
export const formatUser = (user: User): User => {
  return {
    ...user,
  };
};

/**
 * 사용자 이름 생성 (이메일로부터)
 */
export const extractNameFromEmail = (email: string): string => {
  return email.split("@")[0];
};

export const authEntityUtils = {
  isTokenExpired,
  formatUser,
  extractNameFromEmail,
};
